interface StringProps {
  title: string;
  actions?: React.ReactNode;
  children: string | null;
}

interface BooleanProps {
  title: string;
  actions?: React.ReactNode;
  hasDetails: boolean;
  children: React.ReactNode;
}

type Props = StringProps | BooleanProps;

const isString = (props: Props): props is StringProps => {
  return !('hasDetails' in props);
};

export function OptionalDetailsSection(props: Props) {
  if (isString(props)) {
    return (
      <OptionalDetailsSection
        title={props.title}
        actions={props.actions}
        hasDetails={!!props.children}
      >
        <p className="whitespace-pre-wrap text-body2">{props.children}</p>
      </OptionalDetailsSection>
    );
  }

  return (
    <>
      <h2 className="my-4 flex items-center gap-2 font-sans text-subtitle1">
        {props.title}
        {props.actions}
      </h2>
      {props.hasDetails ? props.children : <NoInformationEntered />}
    </>
  );
}

export function NoInformationEntered() {
  return <p className="text-body2 italic">No information entered</p>;
}
